import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { resolveNotificationPollMs } from "@/modules/notifications/domain/config";
import { notificationsApi } from "./notifications-client";

export const notificationKeys = {
  all: ["notifications"] as const,
  summary: () => ["notifications", "summary"] as const,
  unreadCount: () => ["notifications", "unread-count"] as const,
  list: (params?: {
    limit?: number;
    offset?: number;
    unreadOnly?: boolean;
    type?: string;
  }) => ["notifications", "list", params ?? {}] as const,
};

export type NotificationsListParams = {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
  type?: string;
};

export function useNotificationSummaryQuery(enabled = true) {
  return useQuery({
    queryKey: notificationKeys.summary(),
    queryFn: () => notificationsApi.getSummary(),
    enabled,
    refetchInterval: () => {
      if (typeof document !== "undefined" && document.hidden) {
        return false;
      }
      return resolveNotificationPollMs();
    },
  });
}

export function useMarkNotificationReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationsApi.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}

export function useNotificationsListQuery(
  params: NotificationsListParams,
  enabled = true,
) {
  return useQuery({
    queryKey: notificationKeys.list(params),
    queryFn: () => notificationsApi.list(params),
    enabled,
  });
}

export function useMarkAllNotificationsReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
